import { AnyoTalk } from 'projects/app-core/src/app/talks/models/AnyoTalk';
import { TherapistExpertLevel } from 'projects/app-core/src/models/TherapistExpertLevel';
import { TherapyConcerns } from 'projects/app-core/src/models/TherapyConcerns';
import { TherapyVerticals } from 'projects/app-core/src/models/TherapyVerticals';
import { ICategory } from '../../../../app-core/src/models/ICategory';
import { Instructor } from './Instructors';
import { UserInterestTags } from './UserInterestTag';
import { BytesCategory } from './anyoBytesCategory';
import { AnyoEvents } from './events/AnyoEvents';

export interface MasterDataResponse {
  chatProfilingGroups: ChatProfilingGroups[];
  avatarNames: AvatarNames[];
  avatarImages: AvatarNames[];
  listenerSpecialization: ListenerSpecialization[];
  partnerSectors: CommonData[];
  partnerType: CommonData[];
  noOfSubscriptions: CommonData[];
  languages: Languages[];
  areasOfExpertise: CommonData[];
  qualifications: CommonData[];
  planDuration: Languages[];
  genre: Genre[];
  categories: ICategory[];
  routineGroup: Languages[];
  routineTiming: Languages[];
  difficultyLevels: Languages[];
  instructors: Instructor[];
  bytesCategories: BytesCategory[];
  circleReportProblems: circleReportProblems[];
  eventCategories: EventCategories[];
  talksCategories: Array<GenericMasterData>;
  therapistExpertLevel: TherapistExpertLevel[];
  therapyConcerns: TherapyConcerns[];
  therapyVerticals: TherapyVerticals[];
  userInterestTags: UserInterestTags[];
  anyoTalks: AnyoTalk[];
  events: Array<AnyoEvents>;
  therapyPackExpertise: Array<TherapyPacksExpertise> | undefined;
  seasonalUserInterestTags: Array<SeasonalUserInterestTags> | undefined;
  anyoRules: Array<AnyoRules>;
}

export interface LyfisMasterDataResponse {
  RuleEngineFacts?: Array<RuleEngineFacts>;
  LyfisDiseases?: Array<LyfisDisease>;
  LyfisLabMarkers?: Array<LyfisLabMarker>;
}

export interface LyfisLabMarker extends GenericMasterData {
  /** Unique key used by diseases to reference this marker (e.g., "hba1c") */
  markerKey: string;
  /** All acceptable LOINC codes for this marker (comma-separated) */
  loincCodes: string;
  /** Strict unit required in lab meta; no conversions are performed */
  requiredUnit: string;
  /** Optional recommended cadence window in days */
  cadenceDays?: number;
  /** Whether this marker is active */
  active?: boolean;
  derived?: boolean;
}

export interface LyfisDisease {
  m_id: string;
  data: string;
  displayName?: string;
  icdCode?: string;
  active?: boolean;
  description?: string;
  image?: string;
  loadingImage?: string;
  estimatedMinutes?: number;
  order?: number;
  labBioMarkers?: string[];
  RuleEngineFacts: Array<RuleEngineFacts>;
  LyfisDiseases: Array<LyfisDiseases>;
  LyfisQuestionCategories: Array<LyfisQuestionCategory>;
}

export interface LyfisDiseases extends GenericMasterData {
  icdCode: string;
  active: boolean;
}

export interface LyfisQuestionCategory extends GenericMasterData {
  code: string;
  order?: number;
  active?: boolean;
}

interface AvatarNames {
  data: string;
  gender?: string;
  isAvailable?: string;
  status?: string;
  m_id?: string;
}

interface circleReportProblems {
  data: string;
  m_id: string;
}

interface Languages {
  data: string;
  status?: string;
  m_id?: string;
}

export interface CommonData {
  data: string;
  status?: string;
}

export interface ListenerSpecialization {
  data: string;
  status?: boolean;
  m_id?: string;
}

export interface Genre {
  data: string;
  m_id: string;
}

export interface EventCategories {
  data: string;
  m_id: string;
}

export interface ChatProfilingGroups {
  _id: string;
  category: string;
  subCategory: SubCategory[];
}

export interface SubCategory {
  key: string;
  value: string;
}

export interface GenericMasterData {
  data: string;
  m_id: string;
}

export interface TherapyPacksExpertise extends GenericMasterData {
  expert_title: string;
  stream: string;
  stream_id: string;
}

export interface SeasonalUserInterestTags extends UserInterestTags {
  active: boolean;
  addedBy: string;
  addedOn: Date;
  applicablePartnerIds?: string[];
  expertIds: string[];
}

export interface AddUserInterestTagsRequest {
  tag: string;
  imageUrl: string;
  partnerIds?: string[];
  expertIds: string[];
  updateInterestId?: string;
  active: boolean;
}

export interface AnyoRules extends GenericMasterData {
  applicableFacts: string[];
  active: boolean;
  outCome: string[];
  rule: string;
}

export interface RuleEngineFacts extends GenericMasterData {
  dataType: string;
  description: string;
  active: boolean;
  valueDropdownOption: string;
  applicableFacts?: string[];
  outCome?: string[];
  rule?: string;
  availableOptions?: Array<{ key: string; label: string }>;
}
